import { RootState } from '../store/store';
import { useContext } from 'preact/hooks';
import { StoreContext } from '../contexts/StoreContext';

interface TypedUseSelectorHook<TState> {
    <TSelected>(
        selector: (state: TState) => TSelected,
        equalityFn?: (left: TSelected, right: TSelected) => boolean
    ): TSelected;
}
const useAppSelector: TypedUseSelectorHook<RootState> = selector => {
    const state = useContext(StoreContext);
    return selector(state);
};
export default useAppSelector;
